import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import KitchenTicketSettingServices from '@/modules/settings/kitchen-ticket/KitchenTicketSettingServices';
var ticketSettings = {
  id: '',
  show_local_header: false,
  show_domicile_header: false,
  show_price_per_unit: false,
  show_total_price: false,
  group_by_orders: false,
  show_person_name: '',
  header_font: {
    name: '',
    style: '',
    size: ''
  },
  details_font: {
    name: '',
    style: '',
    size: ''
  },
  small_details_font: {
    name: '',
    style: '',
    size: ''
  },
  print_by: ''
}; // tslint:disable-next-line:max-line-length

var KitchenTicketSettingsModel =
/** @class */
function (_super) {
  __extends(KitchenTicketSettingsModel, _super);

  function KitchenTicketSettingsModel() {
    var _this = _super.call(this, ticketSettings, KitchenTicketSettingServices) || this;

    _this.modelName = 'Ticket';
    _this.request = 'JSON';
    return _this;
  }

  KitchenTicketSettingsModel.prototype.create = function (data, toast, toastConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.request({
              method: 'PUT',
              query: data
            })];

          case 1:
            request = _a.sent();

            if (request.complete) {
              return [2
              /*return*/
              , this.handleSuccess(request.data, request.message, toast)];
            } else {
              this.handleError(request, toast);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return KitchenTicketSettingsModel;
}(BaseModel);

export default KitchenTicketSettingsModel;